import {
	DoubleSide,
	Mesh,
	MeshStandardMaterial,
	Shape,
	ShapeGeometry,
} from 'three';
import { ProjectRenderer } from '../ProjectRenderer';
import { RoomManager } from '../managers/RoomManager';
import { RenderUtils } from '../utils/RenderUtils';
import { ObjectCustomName, ThreeEvent } from '../types';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { FLOOR } = RENDERER_CONFIG;

export class RoomFloor {
	static readonly LAYER = FLOOR.LAYER;
	static readonly ROOM_FLOOR_MATERIAL = new MeshStandardMaterial({
		color: 0xffffff,
		toneMapped: false,
		side: DoubleSide,
	});

	mesh: Mesh | null = null;

	constructor(
		private renderer: ProjectRenderer,
		private manager: RoomManager
	) {}

	private createShape() {
		const vertices = this.manager.vertexList.toArray().reverse();

		const shape = new Shape();
		shape.autoClose = true;

		for (let index = 0; index < vertices.length; index++) {
			const vertex = vertices[index];

			if (!index) shape.moveTo(vertex.position.x, -vertex.position.y);
			else shape.lineTo(vertex.position.x, -vertex.position.y);
		}

		return shape;
	}

	createFloor() {
		let roomSurfaceArea = 0;

		const shape = this.createShape();
		const geometry = new ShapeGeometry(shape);
		geometry.rotateX(-(Math.PI / 2));
		geometry.computeBoundingBox();
		geometry.computeBoundingSphere();

		if (this.mesh) {
			this.mesh.geometry.dispose();
			this.mesh.geometry = geometry;
		} else {
			this.mesh = new Mesh(geometry, RoomFloor.ROOM_FLOOR_MATERIAL.clone());
			this.mesh.position.set(0, FLOOR.POS_Y, 0);
			this.mesh.name = ObjectCustomName.ROOM_FLOOR;

			this.renderer.room.add(this.mesh!);
		}

		roomSurfaceArea = RenderUtils.computePolygonArea(
			this.manager.vertexList.toArray().map((v) => v.position)
		);

		this.renderer.emitter.emit(ThreeEvent.UPDATE_OPTIONS, {
			roomSurfaceArea,
		});
	}

	dispose() {
		if (!this.mesh) return;
		RenderUtils.disposeObject(this.mesh);
		this.mesh = null;
	}
}
